export const ConsumeColumns = [
    {
      accessor: "createDateTime",
      header: "تاریخ",
    },
    {
      accessor: "orderCode",
      header: "جزئیات مصرف",
    },
    {
      accessor: "amount",
      header: "مبلغ",
    },
    
  ];
  